import PageAside from '../../components/pageaside/PageAside'
import Empty from '../empty/Empty'

import './friend.css'

const Friend = ({friends, isCurrent, isSetCurrent, isSetShow}) => {

      if(friends.data){
            return (
                  <div className={isCurrent === 'friend' ? "page_content show" : "page_content"}>
                        <Empty text={`Texto here`}/>
                  </div>
            )
      }

      const onClose = () => {
            isSetShow(false)
            isSetCurrent('home')
      }

      return (
            <div className={isCurrent === 'friend' ? "page_content show" : "page_content"}>
                  <div className="page_section">
                        <div className="friend_content">
                              {
                                    friends.map((item, index) => <>
                                          <div className="friend_row" key={index}>
                                                <div className="friend_row__avatar">
                                                      <img src={item.avatar} alt={item.name} />
                                                </div>
                                                <div className="friend_row__data">
                                                      <strong class="bg_grad">{item.name}</strong>
                                                      <p>{item.description}</p>
                                                      <a href={item.me} target="_blank" rel="noreferrer">xat.me</a>
                                                </div>
                                          </div>
                                    </>)
                              }
                              
                        </div>
                  </div>
                  <PageAside closePage={() => onClose()} title={`Friends`} />
            </div>
      )
}

export default Friend
